import ArchiveGallery from "./ArchiveGallery";

function Canvas() {
  return (
    <ArchiveGallery
      category="canvas"
      showCollectionFilter={false}
      emptyTitle="No canvas artwork found in this section."
    />
  );
}

export default Canvas;
